module.exports = "/assets/1b088b16134086a554602c1e02df9cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BM.png
// module id = 1235
// module chunks = 0